import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';

interface NFCNoSupportProps {
    translations: Record<string, string>;
}

export const NFCNoSupport: React.FC<NFCNoSupportProps> = ({ translations }) => (
    <Card>
        <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
                {translations.ERROR_NFC_NOT_SUPPORTED_TITLE}
            </Typography>
            <Typography>{translations.ERROR_NFC_NOT_SUPPORTED}</Typography>
        </CardContent>
        <CardActions>
            <ButtonLink to="/" text={translations.GLOBAL_HOME_BUTTON} />
        </CardActions>
    </Card>
);
